"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _ComparisonDataDisplay = require("../../ComparisonDataDisplay.styled");
var _services = require("../../../../services");
var _useLocalTheme = _interopRequireDefault(require("../../../../hooks/useLocalTheme"));
var _CustomIconOrImage = _interopRequireDefault(require("../../../shared/CustomIconOrImage"));
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const valueTextFormatting = (value, applyThemeColorToTickIcon) => {
  if (value.text) {
    if (value.text === 'true' || value.text === 'false') {
      return handleBooleanValue(value.text, applyThemeColorToTickIcon);
    } else {
      return value.text;
    }
  } else {
    return '-';
  }
};
const handleBooleanValue = (value, applyThemeColorToTickIcon) => {
  const state = applyThemeColorToTickIcon ? '' : 'success';
  return value === 'true' ? /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    name: 'tick',
    group: "system",
    state: state,
    size: 4
  }) : /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    name: 'close',
    group: "system",
    state: "error"
  });
};
const DefaultSpec = _ref => {
  let {
    value,
    applyShowDifferences,
    specsHeadingWeight = 3
  } = _ref;
  const applyThemeColorToTickIcon = (0, _useLocalTheme.default)('comparison.applyThemeColorToTickIcon');
  const overwrittenThemeName = (0, _useConfig.default)('uiSettings.theme', '');
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.StyledGridColumnContent, {
    shouldAddTableBorders: false
  }, /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.TextDataContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: value !== null && value !== void 0 && value.isLargest && applyShowDifferences ? 4 : specsHeadingWeight,
    noMargin: true,
    text: valueTextFormatting(value, applyThemeColorToTickIcon)
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    appearance: overwrittenThemeName ? 'alt2' : 'primary'
  }, _services.Services.locale.localeString(`Specs.${value.subText}`)))));
};
var _default = DefaultSpec;
exports.default = _default;